module.exports = __webpack_public_path__ + "img/index_bg_project1.4898edd3.jpg";